import React, { useState } from 'react';

interface ExportProps {
  metrics: any;
  currency: 'INR' | 'USD';
  inputs: any;
  portfolioMix: any;
}

const CURRENCY_SYMBOLS = {
  INR: '₹',
  USD: '$',
};

const BudgetCalculatorExportSection: React.FC<ExportProps> = ({ metrics, currency, inputs, portfolioMix }) => {
  const [showModal, setShowModal] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [form, setForm] = useState({ name: '', email: '', company: '' });

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setSubmitted(true);
    setTimeout(() => {
      setShowModal(false);
      setSubmitted(false);
      setForm({ name: '', email: '', company: '' });
      // Here you could trigger actual PDF export logic
    }, 2000);
  };

  const isFormValid = form.name && form.email && form.company;

  return (
    <section className="mb-8 p-4 bg-gray-50 rounded-lg shadow flex gap-4 items-center">
      {/* Export buttons for PDF, Excel, and campaign conversion */}
      <button
        className="bg-primary text-white px-4 py-2 rounded shadow hover:bg-primary-dark transition"
        onClick={() => setShowModal(true)}
      >
        Export as PDF
      </button>
      <button className="bg-primary text-white px-4 py-2 rounded shadow hover:bg-primary-dark transition">Download Excel</button>
      <button className="bg-green-600 text-white px-4 py-2 rounded shadow hover:bg-green-700 transition">Convert to Campaign</button>

      {/* Modal for lead capture */}
      {showModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-30">
          <div className="bg-white rounded-lg shadow-lg p-8 w-full max-w-md relative">
            <button
              className="absolute top-2 right-2 text-gray-400 hover:text-gray-700"
              onClick={() => setShowModal(false)}
              aria-label="Close"
            >
              ×
            </button>
            {!submitted ? (
              <form onSubmit={handleSubmit} className="flex flex-col gap-4">
                <h3 className="text-lg font-semibold mb-2">Enter details to export PDF</h3>
                <input
                  type="text"
                  name="name"
                  placeholder="Your Name"
                  value={form.name}
                  onChange={handleChange}
                  className="border border-gray-300 rounded px-3 py-2"
                  required
                />
                <input
                  type="email"
                  name="email"
                  placeholder="Your Email"
                  value={form.email}
                  onChange={handleChange}
                  className="border border-gray-300 rounded px-3 py-2"
                  required
                />
                <input
                  type="text"
                  name="company"
                  placeholder="Company Name"
                  value={form.company}
                  onChange={handleChange}
                  className="border border-gray-300 rounded px-3 py-2"
                  required
                />
                <button
                  type="submit"
                  className={`bg-primary text-white px-4 py-2 rounded shadow hover:bg-primary-dark transition ${!isFormValid ? 'opacity-50 cursor-not-allowed' : ''}`}
                  disabled={!isFormValid}
                >
                  Export PDF
                </button>
              </form>
            ) : (
              <div className="flex flex-col items-center justify-center gap-4 py-8">
                <span className="text-green-600 text-3xl">✔️</span>
                <div className="text-lg font-semibold text-gray-700">Thank you! Your PDF will download shortly.</div>
              </div>
            )}
          </div>
        </div>
      )}
    </section>
  );
};

export default BudgetCalculatorExportSection;
